export enum StepType {
  MERGE = "merge",
  NAME = "name",
  MAP = "map",
}
